export function statusBadgeClasses(color) {
  switch (color) {
    case "green":
      return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case "yellow":
      return "bg-amber-100 text-amber-800 border-amber-200";
    case "red":
      return "bg-rose-100 text-rose-800 border-rose-200";
    case "completed":
      return "bg-slate-100 text-slate-700 border-slate-200";
    default:
      return "bg-slate-100 text-slate-700 border-slate-200";
  }
}

export function statusLabel(color, status) {
  if (status === "completed") return "Completed";
  if (color === "green") return "On Track";
  if (color === "yellow") return "Past Deadline";
  if (color === "red") return "Overdue";
  return "In Progress";
}

export function statusDotClass(color) {
  switch (color) {
    case "green":
      return "bg-emerald-500";
    case "yellow":
      return "bg-amber-500";
    case "red":
      return "bg-rose-500";
    case "completed":
      return "bg-slate-400";
    default:
      return "bg-slate-400";
  }
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
